var vec3 = require('@antv/gl-matrix/lib/gl-matrix/vec3');

module.exports = vec3;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/matrix/vec3.js
// module id = 102
// module chunks = 0 1 2